import styles from "./tab.module.scss";

interface TabProps extends React.HTMLAttributes<HTMLDivElement> {
  title: string;
  children: React.ReactNode;
  active?: boolean;
  className?: string;
  isParentTab?: boolean;
}
const Tab: React.FC<TabProps> = ({ title, children, active, className, isParentTab = false, ...props }: TabProps) => {
  return (
    <div
      className={[
        isParentTab ? styles.parentTabWrapper : styles.tabWrapper,
        className,
        active && styles.activeTab,
      ].join(" ")}
      {...props}
    >
      <div className={styles.tab}>
        <div className={styles.tabTitle}>
          {title} {children}
        </div>
      </div>
    </div>
  );
};
export default Tab;
